import { isPresent } from "@/lib/utils"

import ApiClient from "@/lib/api-client"

export default {
  namespaced: true,

  state: {},

  actions: {
    fetchItems(
      { commit },
      {
        contentType,
        duration,
        offset,
        limit,
        dynamicDirection,
        includeCurrent,
        withTags,
        orderBy,
        withAllTags
      }
    ) {
      let params = {
        offset,
        limit,
        order_by: orderBy
      }

      if (isPresent(dynamicDirection) && isPresent(duration)) {
        params = {
          ...params,
          duration,
          direction: dynamicDirection,
          include_current: includeCurrent
        }
      }

      if (isPresent(withTags)) {
        params = {
          ...params,
          with_tags: withTags,
          with_all_tags: withAllTags
        }
      }

      return ApiClient.get(`/content/${contentType}`, {
        params
      }).then(res => {
        res.data.items.forEach(page => {
          commit(
            "pages/setPageAccess",
            { pageId: page.data.id, access: page.access },
            { root: true }
          )
        })

        return res.data.items
      })
    }
  },

  mutations: {},

  getters: {}
}
